export default {
    noOptions: 'Список пуст',
    noResult: 'Элементы не найдены',
    selected: 'Выбрано',
    notSelected: 'Не выбрано',
};
